import { Alpine } from 'alpinejs';

import { pushToDataLayer } from '../front/tracking.ts';

function gtm(Alpine: Alpine) {
    Alpine.magic('dataLayer', () => pushToDataLayer);
}

export default gtm;
